import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["auto-bid-status"]

  static values = {
    bidderOnlyBidMessages: Boolean,
    commissionBids: Object,
    didUserBid: Boolean,
    isUserApproved: Boolean,
    previewBidButton: Boolean,
    userSlug: String
  }

  connect() {
    this.isUserBidding = this.didUserBidValue
  }

  setUserBidding() {
    this.isUserBidding = true
  }

  showCurrentBidAndBidButtonElements({ detail: { currentBidAndBidButton } }) {
    currentBidAndBidButton.displayElements(this.userSlugValue, this.isUserApprovedValue, this.previewBidButtonValue, this.#showBidMessage)

    if (this.hasAutoBidStatusOutlet) {
      this.autoBidStatusOutlet.update(currentBidAndBidButton.currentBidAmountCentsValue)
    }
  }

  showUpcomingLotElements({ detail: { webcastLot } }) {
    if (this.isUserApprovedValue) {
      webcastLot.displayElements(this.commissionBidsValue[webcastLot.slugValue])
    }
  }

  updateCommissionBids({ detail: { commissionBids } }) {
    this.commissionBidsValue = commissionBids
  }

  get #showBidMessage() {
    return this.bidderOnlyBidMessagesValue ? this.isUserBidding : true
  }
}
